import React from 'react';
import { getManagementCompanyPath } from '@finect/front-resources/Products';
import styled, { useTheme } from 'styled-components';
import { AppLink } from '@finect/tabular-core/AppLink';
import { getManagementCompanyIconUrl } from '../utils';
import { animationShow } from '../../utils/animations';
var Inner = styled(AppLink).withConfig({
  displayName: "Medium__Inner",
  componentId: "sc-1bzx077-0"
})(["display:block;flex-grow:1;flex-shrink:0;width:100%;border:1px solid ", ";border-radius:8px;box-shadow:", ";cursor:pointer;:hover{box-shadow:", ";}background-color:", ";", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.terciaryL;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.shadows.lightBlack;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.shadows.extraBlack;
}, function (_ref4) {
  var theme = _ref4.theme;
  return "".concat(theme.cardsBackgroundColor);
}, animationShow);
var Header = styled.div.withConfig({
  displayName: "Medium__Header",
  componentId: "sc-1bzx077-1"
})(["padding:24px;text-align:center;"]);
var Image = styled.img.withConfig({
  displayName: "Medium__Image",
  componentId: "sc-1bzx077-2"
})(["width:50px;height:50px;border-radius:4px;margin-bottom:10px;"]);
var TitleBlock = styled.div.withConfig({
  displayName: "Medium__TitleBlock",
  componentId: "sc-1bzx077-3"
})(["height:32px;"]);
var Title = styled.h5.withConfig({
  displayName: "Medium__Title",
  componentId: "sc-1bzx077-4"
})(["display:block;font-size:14px;font-weight:700;line-height:16px;color:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.terciaryD;
});
export var Medium = function Medium(_ref6) {
  var managementCompany = _ref6.managementCompany,
    productType = _ref6.productType;
  var theme = useTheme();
  var imageSrc = getManagementCompanyIconUrl(managementCompany);
  var url = getManagementCompanyPath(theme, productType, managementCompany);
  return React.createElement(Inner, {
    href: url
  }, React.createElement(Header, null, React.createElement(Image, {
    src: imageSrc
  }), React.createElement(TitleBlock, null, React.createElement(Title, null, managementCompany.name))));
};